export const EASTERN_TIME_ZONE = 'America/New_York';

const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
const EXPLICIT_ZONE_PATTERN = /(?:Z|[+-]\d{2}:?\d{2})$/i;

function parseServerDate(value) {
  if (typeof value !== 'string' || value.trim() === '') return null;

  const normalized = value.trim();
  // Noon UTC keeps a date-only business date on the same calendar day in
  // every Eastern offset, including daylight-saving transitions.
  const dateValue = DATE_ONLY_PATTERN.test(normalized)
    ? `${normalized}T12:00:00Z`
    : EXPLICIT_ZONE_PATTERN.test(normalized)
      ? normalized.replace(' ', 'T')
      : `${normalized.replace(' ', 'T')}Z`;
  const date = new Date(dateValue);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatEasternDate(value, options = {}) {
  const date = parseServerDate(value);
  if (!date) return value || '';

  return new Intl.DateTimeFormat('en-US', {
    ...options,
    timeZone: EASTERN_TIME_ZONE,
  }).format(date);
}

export function easternCalendarYear(date = new Date()) {
  return new Intl.DateTimeFormat('en-US', {
    timeZone: EASTERN_TIME_ZONE,
    year: 'numeric',
  }).format(date);
}

export function easternGreeting(date = new Date()) {
  const hour = Number(new Intl.DateTimeFormat('en-US', {
    timeZone: EASTERN_TIME_ZONE,
    hour: 'numeric',
    hourCycle: 'h23',
  }).format(date));

  if (hour < 12) return 'Good morning';
  if (hour < 18) return 'Good afternoon';
  return 'Good evening';
}
